export class AuthPayload {
    aud: Array<string>;
    exp: number;
    iat: number;
    iss: string;
    mil: string;
    nam: string;
    rol: string;
    sub: string;
}